import { translate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { translateCorexError } from '../../utils/translations.js';

var KeycloakTheme = /** @class */ (function (_super) {
    __extends(KeycloakTheme, _super);
    function KeycloakTheme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notification = '';
        _this.isAutoSubmitting = false;
        return _this;
    }
    Object.defineProperty(KeycloakTheme.prototype, "title", {
        get: function () {
            switch (this.kcContext.pageId) {
                case 'login.ftl':
                    return translate('main-navigation.login');
                case 'login-update-password.ftl':
                    return translate('password-reset.title');
                case 't_and_c.ftl':
                    return translate('tnc.title');
                case 'error.ftl':
                    return translate('keycloak-error.title');
                case 'info.ftl':
                    return translate('keycloak-info.title');
                case 'login-config-totp.ftl':
                    return translate('keycloak-totp.title');
                case 'login-reset-password.ftl':
                    return translate('password-reset.title');
                case 'login-page-expired.ftl':
                    return translate('login-page-expired.title');
                case 'configure-sms-otp.ftl':
                    return translate('configure-sms-otp.title');
                case 'login-sms.ftl':
                    return translate('login-sms.title');
                default:
                    return translate('keycloak-info.title');
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakTheme.prototype, "description", {
        get: function () {
            switch (this.kcContext.pageId) {
                case 'login-config-totp.ftl':
                    return translate('keycloak-totp.description');
                default:
                    return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    KeycloakTheme.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setNotification();
                return [2 /*return*/];
            });
        });
    };
    KeycloakTheme.prototype.setNotification = function () {
        if (this.kcContext.message &&
            this.kcContext.message.summary &&
            this.kcContext.message.type === 'success') {
            var summary = this.kcContext.message.summary;
            var transformedMessage = translateCorexError(summary);
            var isTranslationPresent = translate("keycloak.corex.error." + transformedMessage) !== '';
            this.notification = isTranslationPresent
                ? translate("keycloak.corex.error." + transformedMessage)
                : this.kcContext.message.summary;
        }
    };
    KeycloakTheme.prototype.getNotification = function (event) {
        this.notification = event.detail[0];
    };
    KeycloakTheme.prototype.onAutoSubmitting = function (isSubmitting) {
        this.isAutoSubmitting = isSubmitting;
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakTheme.prototype, "kcContext", void 0);
    KeycloakTheme = __decorate([
        Component({
            name: 'corex-keycloak-theme',
        })
    ], KeycloakTheme);
    return KeycloakTheme;
}(Mixins(MagicConfigMixin)));

export default KeycloakTheme;
